module.exports = __webpack_public_path__ + "img/1.04050e83.jpg";